import { defineStore } from 'pinia'
import type { ResponseResult } from '@/core/models/api-responses'
import { LocationDTO } from '../models/location'
import locationService from '../services/location-service'

interface LocationState {
    locations: LocationDTO[]
    isLoading: boolean
    error: string | null
}

export const useLocationStore = defineStore('location', {
    state: (): LocationState => ({
        locations: [],
        isLoading: false,
        error: null
    }),

    actions: {
        /**
         * Fetch all locations without filters
         */
        async fetchAllLocations(): Promise<void> {
            this.isLoading = true
            this.error = null

            try {
                const response: ResponseResult<LocationDTO[]> = await locationService.getAll()

                if (response.isSuccess && response.data) {
                    this.locations = response.data
                } else {
                    this.error = response.error.message || 'Erro ao carregar localizações'
                    this.locations = []
                }
            } catch (error) {
                console.error('Error fetching locations:', error)
                this.error = 'Erro ao carregar localizações'
                this.locations = []
            } finally {
                this.isLoading = false
            }
        },

        /**
         * Clear error state
         */
        clearError(): void {
            this.error = null
        },

        /**
         * Reset store state
         */
        resetStore(): void {
            this.locations = []
            this.isLoading = false
            this.error = null
        }
    }
})